import { useGlobalForm } from '../lib/react-form';
import { parseTokenId } from '../utils/token';

export function useWithdrawForm(token_id?: string) {
  const network = token_id ? parseTokenId(token_id).network : null;
  return useGlobalForm({
    name: 'withdraw',
    values: {
      default: {
        otp: '',
        network: network ?? null,
        token_id: token_id ?? null,
        amount: '',
      },
    },
  });
}
